import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import {
  createShareClass,
  getShareClass,
  updateShareClass,
} from "../../../apis/shareClassApi";
import { getAppProducts } from "../../../apis/AppProductsApi";
import { shareClassScheme } from "../../../Validations/shareClassValidations";
import { useParams, useNavigate } from "react-router-dom";
import langauge from "../../../lib/common/languages.json";

export default function AddShareClass() {
  const [loading, setLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [productList, setProductList] = useState([]);

  const [initialValues, setInitialValues] = useState({
    name: "",
    type: "",
    typeDescription: "",
    years: "",
    yearsDescription: "",
    catId: "",
    crmShareClassGuid: "",
    secondaryDescription: "",
    language: "",
  });

  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      console.log("fetching products");
      const res = await getAppProducts();
      console.log(res, "products list");
      console.log(res?.result || [], "products array");

      setProductList(res?.result || []);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  useEffect(() => {
    if (id) {
      setEditLoading(true);
      editShareClass(id);
    }
  }, [id]);

  const editShareClass = async (id) => {
    try {
      const res = await getShareClass(id);
      console.log(res, "edit share class");
      if (res?.result) {
        setInitialValues({
          name: res.result.name || "",
          type: res.result.type || "",
          typeDescription: res.result.typeDescription || "",
          years: res.result.years || "",
          yearsDescription: res.result.yearsDescription || "",
          catId: res.result.catId || "",
          crmShareClassGuid: res.result.crmShareClassGuid || "",
          secondaryDescription: res.result.secondaryDescription || "",
          language: res.result.language,
        });
      }
    } catch (e) {
      console.error("Error fetching share class:", e);
    } finally {
      setEditLoading(false);
    }
  };

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: shareClassScheme,
    onSubmit: async (values) => {
      console.log(values, "mmmmmmmmmmmmmmmmm");
      try {
        setLoading(true);
        let res;

        if (id) {
          res = await updateShareClass(id, values);
        } else {
          res = await createShareClass(values);
          console.log(res);
        }

        setLoading(false);
        formik.resetForm();
        navigate("/shareclass");
      } catch (error) {
        console.error("Error submitting form:", error);
        setLoading(false);
      }
    },
  });

  const backClick = () => {
    navigate("/shareclass");
  };

  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            <i
              className="fas fa-arrow-left"
              style={{
                marginRight: "30px",
                fontSize: "20px",
                cursor: "pointer",
              }}
              onClick={backClick}
            />

            <div className="my-3 p-3 bg-body rounded shadow-sm">
              <h3>{id ? "Edit" : "Add"} Share Class</h3>

              {editLoading ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: "50px", padding: "7px 30px" }}
                >
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <form onSubmit={formik.handleSubmit} className="formMaxwidth">
                  {" "}
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      ShareClass Name <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="name"
                      value={formik.values.name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.name && formik.touched.name && (
                      <span className="text-danger">{formik.errors.name}</span>
                    )}
                  </div>
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      ShareClass Type <span className="text-danger">*</span>
                    </label>

                    <select
                      className="form-control"
                      name="type"
                      value={formik.values.type}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    >
                      <option value="">Select Type</option>
                      <option value="Income">Income</option>
                      <option value="Growth">Growth</option>
                    </select>

                    {formik.errors.type && formik.touched.type && (
                      <span className="text-danger">{formik.errors.type}</span>
                    )}
                  </div>
                  <div className="input-block mb-3">
                    <label className="col-form-label">Type Description</label>
                    <textarea
                      className="form-control"
                      name="typeDescription"
                      value={formik.values.typeDescription}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      rows={3}
                    />
                    {formik.errors.typeDescription &&
                      formik.touched.typeDescription && (
                        <span className="text-danger">
                          {formik.errors.typeDescription}
                        </span>
                      )}
                  </div>
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Secondary Description
                    </label>
                    <textarea
                      className="form-control"
                      name="secondaryDescription"
                      value={formik.values.secondaryDescription}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      rows={3}
                    />
                    {formik.errors.secondaryDescription &&
                      formik.touched.secondaryDescription && (
                        <span className="text-danger">
                          {formik.errors.secondaryDescription}
                        </span>
                      )}
                  </div>
                  <div className="input-block mb-3">
                    <label className="col-form-label">Years</label>
                    <input
                      className="form-control"
                      type="number"
                      name="years"
                      value={formik.values.years}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </div>
                  <div className="input-block mb-3">
                    <label className="col-form-label">Years Description</label>
                    <textarea
                      className="form-control"
                      name="yearsDescription"
                      value={formik.values.yearsDescription}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      rows={3}
                    />
                  </div>
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      CRM Share Class GUID{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="crmShareClassGuid"
                      value={formik.values.crmShareClassGuid}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.crmShareClassGuid &&
                      formik.touched.crmShareClassGuid && (
                        <span className="text-danger">
                          {formik.errors.crmShareClassGuid}
                        </span>
                      )}
                  </div>
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Product List <span className="text-danger">*</span>
                    </label>

                    <select
                      className="form-control"
                      name="catId"
                      value={formik.values.catId}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    >
                      <option value="">Select Product</option>

                      {productList.map((product) => (
                        <option key={product.id} value={product.id}>
                          {product.name}
                        </option>
                      ))}
                    </select>

                    {formik.errors.catId && formik.touched.catId && (
                      <span className="text-danger">{formik.errors.catId}</span>
                    )}
                  </div>
                  <div className="input-block mb-3">
                    <label className="col-form-label">Language *</label>

                    <select
                      className="form-select"
                      name="language"
                      value={formik.values.language}
                      onChange={formik.handleChange}
                    >
                      <option value="">Select Language</option>

                      {langauge.map((lang) => (
                        <option key={lang.code} value={lang.code}>
                          {lang.label}
                        </option>
                      ))}
                    </select>
                    {formik.errors.language && formik.touched.language && (
                      <span className="text-danger">
                        {formik.errors.language}
                      </span>
                    )}
                  </div>
                  {loading ? (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: "50px", padding: "7px 30px" }}
                    >
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <button className="btn btn-primary" type="submit">
                      {id ? "Update" : "Submit"}
                    </button>
                  )}
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
